module.exports = __webpack_public_path__ + "static/media/4.9bd44073.jpg";